<ion-header>
  <app-header [backIcon]="false" [menuIcon]="false" [middleIconLink]="false"></app-header>
</ion-header>

<ion-content class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>{{ "__ACCOUNT_HELLO__" | translate }} {{ user?.first_name }}</ion-card-title>
      <ion-card-subtitle>
        {{ "__ACCOUNT_PLEASE_READ_TERMS__" | translate }}
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <h2>{{ "__ACCOUNT_EMPLOYEE_CONSENT_FOR_USE_AI_SALES_TOOL__" | translate }}</h2>

      <ion-text color="medium">
        <h3>{{ "__ACCOUNT_PURPOSE_OF_PROCESSING__" | translate }}:</h3>
        <p> {{ "__ACCOUNT_AI_BASED_TOOL_DESC__" | translate }}</p>

        <h3>{{ "__ACCOUNT_DATA_CONTROLLER_TITLE__" | translate }}:</h3>
        <p>{{ "__ACCOUNT_DATA_CONTROLLER_TEXT__" | translate }} </p>

        <h3>{{ "__ACCOUNT_CATEGORIES_TITLE__" | translate }}:</h3>
        <ul>
          <li>{{ "__ACCOUNT_CATEGORIES_LIST_1__" | translate }}</li>
          <li>{{ "__ACCOUNT_CATEGORIES_LIST_2__" | translate }}</li>
          <li>{{ "__ACCOUNT_CATEGORIES_LIST_3__" | translate }}</li>
        </ul>

        <h3>{{ "__ACCOUNT_LEGAL_BASIS_TITLE__" | translate }}:</h3>
        <p>{{ "__ACCOUNT_LEGAL_BASIS_TEXT__" | translate }}</p>

        <h3>{{ "__ACCOUNT_USE_ACCESS_TITLE__" | translate }}:</h3>
        <p>{{ "__ACCOUNT_USE_ACCESS_TEXT_1__" | translate }}</p>
        <p>{{ "__ACCOUNT_USE_ACCESS_TEXT_2__" | translate }}</p>

        <h3>{{ "__ACCOUNT_RETENTION_TITLE__" | translate }}:</h3>
        <p>{{ "__ACCOUNT_RETENTION_TEXT__" | translate }}</p>

        <h3>{{ "__ACCOUNT_STORAGE_TITLE__" | translate }}:</h3>
        <p>{{ "__ACCOUNT_STORAGE_TEXT__" | translate }}</p>

        <h3>{{ "__ACCOUNT_RIGHTS_TITLE__" | translate }}:</h3>
        <ol>
          <li>{{ "__ACCOUNT_RIGHTS_LIST_1__" | translate }}</li>
          <li>{{ "__ACCOUNT_RIGHTS_LIST_2__" | translate }}</li>
          <li>{{ "__ACCOUNT_RIGHTS_LIST_3__" | translate }}</li>
          <li>{{ "__ACCOUNT_RIGHTS_LIST_4__" | translate }}</li>
          <li>{{ "__ACCOUNT_RIGHTS_LIST_5__" | translate }}</li>
        </ol>

        <h3>{{ "__ACCOUNT_CONSENT_TITLE__" | translate }}</h3>
        <ol>
          <li>{{ "__ACCOUNT_CONSENT_LIST_1__" | translate }}</li>
          <li>{{ "__ACCOUNT_CONSENT_LIST_2__" | translate }}</li>
          <li>{{ "__ACCOUNT_CONSENT_LIST_3__" | translate }}</li>
        </ol>

      </ion-text>

      <ion-grid>
        <ion-row class="ion-justify-content-end ion-margin-top btn-row">
          <ion-button class="decline" (click)="onDecline()">{{ "__ACCOUNT_DECLINE__" | translate }}</ion-button>
          <ion-button class="accept" id="acceptBtn" (click)="onAccept()">{{ "__ACCOUNT_ACCEPT__" | translate }}</ion-button>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</ion-content>
